export const LOAD_DATA = 'at/licenses/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'at/licenses/LOAD_DATA_SUCCESS'
export const LOAD_DATA_FAILURE = 'at/licenses/LOAD_DATA_FAILURE'
export const LOADED_DATA_SET = 'at/licenses/LOADED_DATA_SET'



// WEBPACK FOOTER //
// ./web/js/administration/licenses/actionTypes.js